<div class="row modal-bar border-bottom-0 mb-0">
  <div class="col-sm-6">
    <h5 class="modal-title pb-0">{{'COMPONENTS.ORDER.EDIT-ORDER.MODAL-TITLE.EDIT-PRICE' | translate}}</h5>
  </div>
  <div class="col-sm-6">
    <div class="modal-close align-items-end">
      <span>{{'SALES-ENTITY-MODIFICATION.LISTVIEW.HEADER.PRICE.ORIGINAL-PRICE' | translate}} = <b>{{ orderLine.Total | currency:'EUR' | replaceOnEmpty }}</b></span>
    </div>
  </div>
</div>

<hr class="mb-0">

@if ((orderLine.ProductType == 1 || orderLine.ProductType == 4 || orderLine.ProductType == 7) && !orderLine.PriceVariants?.length) {
  <div class="alert alert-warning d-flex align-items-center mb-0 mt-3" role="alert">
    <i class="fas fa-exclamation-triangle"></i>
    {{'SALES-ENTITY-MODIFICATION.DIALOG.WARNING.NO-PRICE-VARIANTS' | translate}}
  </div>
}

<div class="row">
  <div class="col-md-6">
    <form [formGroup]="form" class="form-content">
      <div class="section-wrapper">
        @if (orderLine.ProductType == 1 || orderLine.ProductType == 4 || orderLine.ProductType == 7) {
          <div class="row mg-b-25 g-2 align-items-center">
            <div class="col-6 d-flex align-items-center">
              <i class="fas fa-money-bill-wave-alt"></i>
              <label class="form-control-label">{{'SALES-ENTITY-MODIFICATION.DIALOG.LABEL.PRICE-VARIATION' | translate | uppercase}}</label>
            </div>
            @if (orderLine.PriceVariants?.length) {
              <div class="col-6">
                <ng-select name="selectedVariant" formControlName="selectedVariant" [items]="orderLine.PriceVariants" bindLabel="VariationName"
                  placeholder="{{ 'SALES-ENTITY-MODIFICATION.DIALOG.PLACEHOLDER.PRICE-VARIATION' | translate }}"
                  [clearable]="false" notFoundText="{{ 'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}" (change)="onSelectedPriceVariantChange($event)">
                </ng-select>
              </div>
            }
          </div>
        }
    @if (orderLine.ProductType == 1 || orderLine.ProductType == 4 || orderLine.ProductType == 7) {
      <div class="row mg-b-25 g-2 align-items-center">
        <div class="col-6 d-flex align-items-center">
          <i class="fas fa-wallet"></i>
          <label class="form-control-label m-0">{{'SALES-ENTITY-MODIFICATION.DIALOG.LABEL.PRICE' | translate | uppercase}}</label>
        </div>
        <div class="col-6">
          <p class="info-label mb-0">
            {{(selectedVariant.PriceTotal || orderLine.SelectedVariant?.PriceTotal) | currency:'EUR' | replaceOnEmpty}}
          </p>
        </div>
      </div>
    }
    <div class="row mg-b-25 g-2 align-items-center">
      <div class="col-6 d-flex align-items-center">
        <i class="fas fa-receipt"></i>
        <label class="form-control-label">{{'SALES-ENTITY-MODIFICATION.LISTVIEW.HEADER.PRICE.SET-MANUAL-PRICE' | translate | uppercase}}</label>
      </div>
      <div class="col-6">
        <button class="btn btn-primary w-100 m-0 d-flex align-items-center" (click)="openDialog()">
          <i class="fas fa-exchange-alt col-3"></i>
          <p class="info-label d-inline text-center col-9">{{'CUSTOM.BUTTON.STATE.LIST.EDIT' | translate }}</p>
        </button>
      </div>
    </div>
  </div>
</form>
</div>

<div class="col-md-6">
  <div class="info-highlight mt-3">
    @if (orderLine.ProductType == 1 || orderLine.ProductType == 4 || orderLine.ProductType == 7) {
      <div class="row g-2 align-items-center">
        <div class="col-6">
          <p class="info-label mb-0">{{'SALES-ENTITY-MODIFICATION.DIALOG.LABEL.NEW-PRICE-VARIATION' | translate | uppercase}}</p>
        </div>
        <div class="col-6 text-end">
          <p class="info-label mb-0" [class.fw-bold]="selectedVariant.VariationName != null">
            {{selectedVariant.VariationName | replaceOnEmpty:'SALES-ENTITY-MODIFICATION.LISTVIEW.CHECK.UNEDITED' | uppercase}}
          </p>
        </div>
      </div>
    }
    @if (orderLine.ProductType == 1 || orderLine.ProductType == 4 || orderLine.ProductType == 7) {
      <div class="row g-2 align-items-center">
        <div class="col-6">
          <p class="info-label mb-0">{{'SALES-ENTITY-MODIFICATION.DIALOG.LABEL.PRICE-CATEGORY' | translate | uppercase}}</p>
        </div>
        <div class="col-6 text-end">
          <p class="info-label mb-0">
            @if (selectedVariant.PriceTotal) {
              <span class="fw-bold">
                {{selectedVariant.PriceTotal | currency:'EUR' | replaceOnEmpty}}
              </span>
            }
            @if (selectedVariant.PriceTotal == null) {
              <span>
                {{'SALES-ENTITY-MODIFICATION.LISTVIEW.CHECK.UNEDITED' | translate | uppercase}}
              </span>
            }
          </p>
        </div>
      </div>
    }
    <div class="row g-2 align-items-center">
      <div class="col-6">
        <p class="info-label mb-0">{{'SALES-ENTITY-MODIFICATION.DIALOG.LABEL.NEW-PRICE' | translate | uppercase}}</p>
      </div>
      <div class="col-6 text-end">
        @if (newTotal) {
          <p class="info-label d-inline-flex w-100 mb-0">
            {{orderLine.Total | currency:'EUR' | replaceOnEmpty}}
            <span class="flex-grow-1 text-center"> > </span>
            <span class="fw-bold">{{newTotal | currency:'EUR' | replaceOnEmpty}}</span>
          </p>
        }
        @if (newTotal == null) {
          <p class="info-label mb-0">{{'SALES-ENTITY-MODIFICATION.LISTVIEW.CHECK.UNEDITED' | translate | uppercase}}</p>
        }
      </div>
    </div>
    <hr class="text-dark">
    <div class="row g-2 align-items-center">
      <div class="col-6">
        <p class="info-label mb-0">{{'SALES-ENTITY-MODIFICATION.LISTVIEW.HEADER.PRICE.NEW-PRICE-CHANGE' | translate | uppercase}}</p>
      </div>
      <div class="col-6 text-end">
        <span class="info-label">{{changedTotal | currency:'EUR' | replaceOnEmpty:'0'}}</span>
      </div>
    </div>
  </div>
</div>
</div>

<hr>

<div class="text-center">
  <button class="btn btn-primary" [disabled]="!valid" (click)="save()">
    {{'GENERIC.BUTTON.SAVE' | translate | uppercase}}
  </button>
  <button class="btn btn-dark" (click)="dialogRef.close()">
    {{'GENERIC.BUTTON.CANCEL' | translate | uppercase}}
  </button>
</div>
